import { lazy } from "react";

export const Dashboard = lazy(() => import("./Dashboard"));
export const CalendarScreen = lazy(() => import("./CalendarScreen"));
export const LoginScreen = lazy(() => import("./LoginScreen"));
export const PatientsScreen = lazy(() => import("./PatientsScreen"));
export const PatientScreen = lazy(() => import("./PatientScreen"));
export const ProfileScreen = lazy(() => import("./ProfileScreen"));
export const SettingsScreen = lazy(() => import("./SettingsScreen"));
